<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex md12 sm12 lg2 >
                <v-tooltip top>
                    <v-btn slot="activator" class="mt-4" absolute right fab dark top color="primary dark1" append :to="{path: 'add'}">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                    <span>{{$t('Core.Fields.add_new')}}</span>
                </v-tooltip>

            </v-flex>
            <v-flex md12 sm12 lg12>
                <product-sizes-table
                        :append-headers="headers"
                        @refresh="getItems"
                        @delete="deleteItem"
                        :total="total"
                        :loading="loading"
                        :items="items"
                >
                    <template slot="items" slot-scope="{ item }">
                        <td align="center">{{ item.order}}</td>
                        <td align="center">{{ item.notify_count}}</td>
                    </template>
                </product-sizes-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import i18n from '@/i18n'
    import ProductSizesTable from './productSizes/Table'
    export default {
        name: "ProductSizes",
        components: {ProductSizesTable},
        data: () => ({
            items: [],
            initial: true,
            loading: false,
            total: 0,
            pagination: {},
            headers: [
                {
                    sortable: false,
                    text: i18n.t('Pages.ProductSizes.model.order'),
                    value: 'order',
                    align: "center"
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.ProductSizes.model.notify_count'),
                    value: 'notify_count',
                    align: "center"
                }
            ]
        }),
        created () {

        },
        methods: {
            getItems(data = null){
                this.pagination = data;
                if(this.initial){
                    this.setFetching(true);
                }
                this.loading = true;
                this.repositories.productSize.paginate(data, 'product').then(response => {
                    this.items = response.data.data;
                    this.total = response.data.meta.pagination.total;
                }).finally(() => {
                    this.loading = this.initial = false;
                    this.setFetching(false);
                });
            },
            deleteItem(item){
                this.repositories.productSize.delete(item.id).then((response) => {
                    this.$toast.info(response.data.message);
                    this.getItems(this.pagination);
                })
            }
        }
    }
</script>

<style scoped>

</style>
